/* @flow */
import * as React from 'react';
import Timestamp from 'components/Timestamp';
import ScrollWatch from 'components/ScrollWatch';
import LoadingIndicator from 'components/LoadingIndicator';

type Props = {
  groups: PartialGroup[],
  allLoaded: boolean,
  loadNextPage: () => any,
};

class OrganizationClassesTable extends React.Component<Props> {
  render() {
    const rows = this.props.groups.map(group => {
      return (
        <tr key={group.id}>
          <td>{group.class_name}</td>
          <td>{group.user && group.user.signature ? group.user.signature : 'no name'}</td>
          <td>{group.statistics ? group.statistics.message_count : 0}</td>
          <td>{group.subscribers_count || 0}</td>
          <td>
            {group.created_at ? (
              <Timestamp date={new Date(group.created_at)} format="long" />
            ) : (
              <span>error</span>
            )}
          </td>
        </tr>
      );
    });

    return (
      <tbody>
        {rows}
        {!this.props.allLoaded && (
          <tr>
            <td colSpan={99} className="PeopleTableBody-loading">
              <ScrollWatch onEnter={this.props.loadNextPage} threshold={0.2}>
                <LoadingIndicator size="large" />
              </ScrollWatch>
            </td>
          </tr>
        )}
      </tbody>
    );
  }
}

export default OrganizationClassesTable;
